export default __webpack_public_path__ + "static/media/_IMG2476.de9aca05.jpg";